module.exports = __webpack_public_path__ + "static/img/up-color.3eda5ffd.svg";